/**
 * Invite-link API calls. The token is accepted only as a function argument so
 * it never enters Redux state or the token-free organization invitation model.
 */

import { InvitationDetail, Organization } from '../../@types/organization';
import { API_BASE_URL } from '../../apiConfig';
import { ApiFacade } from './apiFacade';

const INVITATIONS_URL = `${API_BASE_URL}/api/v1/invitations`;

function invitationUrl(token: string): string {
    return `${INVITATIONS_URL}/${encodeURIComponent(token)}`;
}

export async function getInvitation(accessToken: string, token: string): Promise<InvitationDetail> {
    return ApiFacade.getJson<InvitationDetail>(invitationUrl(token), { accessToken });
}

export async function acceptInvitation(accessToken: string, token: string): Promise<Organization> {
    return ApiFacade.postJson<Organization>(`${invitationUrl(token)}/accept`, { accessToken });
}

export async function declineInvitation(accessToken: string, token: string): Promise<void> {
    await ApiFacade.postJson<void>(`${invitationUrl(token)}/decline`, { accessToken });
}
